import * as yup from "yup";

import { CustomerTellUsMoreData } from "./new-customer-model";
import { useFormik } from "formik";
import { useTranslation } from "next-i18next";

export function useNewCustomerTellUsMoreFormik(onNext: (data:CustomerTellUsMoreData) => void) {
    const {t} = useTranslation();
    const messageRequired = t("common:common.required");

  const validationSchema = yup.object().shape({
    businessWebsite: yup
    .string()
    .optional(),
    howDidYouHear: yup
    .string()
    .required(messageRequired),
    additionalInfo: yup
    .string()
    .optional()

  });

  const formik = useFormik<CustomerTellUsMoreData>({
    initialValues: {
        businessWebsite: undefined,
        howDidYouHear: "Other",
        additionalInfo: undefined,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
        onNext(values);
    }
  });
  return formik;

}